import { Card, CardContent, Grid, Icon, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DashBoardCardTitleEnum } from '../../../utils/Enums';
import styles from './styles';
import { CardProps } from './types';

const CustomCard = ({ title, subTitle, activeCount, icon, width }: CardProps) => {
    const navigate = useNavigate();
    return (
        <>
            <Card id={`card-${title}`} sx={[styles.card, { width }]}>
                <CardContent id={`card-content-${title}`} sx={styles.cardContent}>
                    <Grid
                        id={`card-container-${title}`}
                        container
                        sx={styles.container}
                        onClick={() => {
                            switch (title) {
                                case DashBoardCardTitleEnum.Admins:
                                    navigate('/admin-management');
                                    break;

                                case DashBoardCardTitleEnum.Members:
                                    navigate('/partner-member', { state: { members: true } });
                                    break;

                                case DashBoardCardTitleEnum.Partners:
                                    navigate('/partner-member');
                                    break;

                                case DashBoardCardTitleEnum.Resources:
                                    navigate('/content-management');
                                    break;

                                default:
                                    break;
                            }
                        }}
                    >
                        <Grid item xs={6} md={6} sm={6}>
                            <Typography id={`card-title-${title}`} component="div" sx={styles.title}>
                                {title}
                            </Typography>
                            <Typography id={`card-subTitle-${subTitle}`} component="div" sx={styles.subTitle}>
                                {subTitle}: {activeCount}
                            </Typography>
                        </Grid>
                        <Typography id={`card-image-${title}`} component="div">
                            <Icon sx={styles.icon}>
                                <img alt="alt" src={`/images/${icon}`} height="100%" />
                            </Icon>
                        </Typography>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
};

export default CustomCard;
